import { Guid } from "@/types"

export interface IProductFamilyDTO {
    id: Guid
    description?: string
}

export interface IProductFamily {
    id: Guid
    description?: string
}

export default class ProductFamily implements IProductFamily {
    constructor(
        public id: Guid,
        public description?: string
    ) {}

    static fromDTO(dto: IProductFamilyDTO): ProductFamily {
        return new ProductFamily(
            dto.id,
            dto.description,
        )
    }
}
